module.exports = __webpack_public_path__ + "static/media/titlelogo.f48a50a6.png";